import { Add, Remove } from "@mui/icons-material";
import {
  Box,
  Modal,
  Typography,
  IconButton,
  Divider,
  Paper,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { putAddDrugInArea } from "../../api/area";
import { countDownEquipment, returnDrug } from "../../api/group";
import { addAllEquipmentsToArea } from "../../api/jahadgar";

export default function CountDrugPop({
  open,
  setOpen,
  data,
  areaId,
  equipment,
}) {
  const [localData, setLocalData] = useState([]);

  useEffect(() => {
    setLocalData(data);
  }, [data]);

  const handleCountChange = (index, type) => {
    const updatedData = [...localData];
    const item = updatedData[index];

    if (type === "add") {
      item.totalCount += 1;
      item.reminder += 1;
    } else if (type === "remove" && item.totalCount > 0) {
      item.totalCount -= 1;
      item.reminder -= 1;
    }

    setLocalData(updatedData);

    if (!item?.drugInfo?.id) return;

    if (type === "add") {
      putAddDrugInArea(areaId, [
        {
          drugId: item.drugInfo.id,
          totalCount: 1,
        },
      ])
        .then((z) => toast.success("دارو انتقال پیدا کرد"))
        .catch(() => {});
    } else if (type === "remove") {
      returnDrug(areaId, item.drugInfo.id, 1)
        .then(() => {
          toast.error("دارو انتقال پیدا کرد")
        })
        .catch((error) => {
          console.error("API error:", error);
        });
    }
  };
  const handleCountChangeEquipment = (index, type) => {
    const updatedData = [...localData];
    const item = updatedData[index];

    if (type === "add") {
      item.totalCount += 1;
      item.reminder += 1;
    } else if (type === "remove" && item.totalCount > 0) {
      item.totalCount -= 1;
      item.reminder -= 1;
    }

    setLocalData(updatedData);

    if (!item?.equipmentInfo?.id) return;

    if (type === "add") {
      addAllEquipmentsToArea(areaId, [
        {
          equipmentId: item.equipmentInfo.id,
          totalCount: 1,
        },
      ])
        .then((z) => toast.error("تجهیزات انتقال پیدا کرد"))
        .catch(() => {});
    } else if (type === "remove") {
      countDownEquipment(areaId, item.equipmentInfo.id, 1)
        .then(() => {
          toast.success("تجهیزات انتقال پیدا کرد")
        })
        .catch((error) => {
          console.error("API error:", error);
        });
    }
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40vw",
    maxHeight: "80vh",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "16px",
    p: 4,
    overflowY: "auto",
  };

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Box sx={style}>
        <Typography variant="h6" mb={2} textAlign="center">
          مدیریت تعداد داروها
        </Typography>
        <Divider sx={{ mb: 2 }} />
        {localData?.map((x, i) => (
          <Paper
            key={x.drugInfo?.id || x.equipmentInfo?.id}
            elevation={2}
            sx={{
              mb: 2,
              p: 2,
              borderRadius: "12px",
              backgroundColor: "#f9f9f9",
            }}
          >
            <Typography variant="subtitle1" textAlign="center" fontWeight={600}>
              {x.drugInfo?.name || x.equipmentInfo?.name}
            </Typography>

            <Box
              mt={2}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              textAlign="center"
            >
              <Box width="25%">
                <Typography variant="body2" color="text.secondary">
                  کم کردن
                </Typography>
                <IconButton
                  color="error"
                  onClick={() => {
                    if (equipment) {
                      handleCountChangeEquipment(i, "remove");
                    } else {
                      handleCountChange(i, "remove");
                    }
                  }}
                >
                  <Remove />
                </IconButton>
              </Box>

              <Box width="25%">
                <Typography variant="body2" color="text.secondary">
                  تعداد کل
                </Typography>
                <Typography>{x.totalCount}</Typography>
              </Box>

              <Box width="25%">
                <Typography variant="body2" color="text.secondary">
                  باقی مانده
                </Typography>
                <Typography>{x.reminder}</Typography>
              </Box>

              <Box width="25%">
                <Typography variant="body2" color="text.secondary">
                  افزودن
                </Typography>
                <IconButton
                  color="primary"
                  onClick={() => {
                    if (equipment) {
                      handleCountChangeEquipment(i, "add");
                    } else {
                      handleCountChange(i, "add");
                    }
                  }}
                >
                  <Add />
                </IconButton>
              </Box>
            </Box>
          </Paper>
        ))}
      </Box>
    </Modal>
  );
}
